// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface HeadphoneIconSignature {
  Element: SVGSVGElement;
}

export const HeadphoneIcon: TOC<HeadphoneIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.486 2 2 6.486 2 12V21C2 21.553 2.448 22 3 22H7C8.103 22 9 21.103 9 20V16C9 14.896 8.103 14 7 14H4V12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12V14H17C15.897 14 15 14.896 15 16V20C15 21.103 15.897 22 17 22H21C21.552 22 22 21.553 22 21V12C22 6.486 17.514 2 12 2ZM7 16L7.001 20H4V16H7ZM17 20H20V16H17V20Z"/>
</svg>
</template>;